import { ConnectComponent } from '../../_components/ConnectComponent'
import { PolicyPresenter } from './Policy.presenter'
import { PolicyView } from './Policy.view'

export const Policy = ConnectComponent(PolicyView, PolicyPresenter)
